// Mirrors React Router's `Location` shape; typed inline to keep this file
// dependency-free and trivially testable.
type PathLike = { pathname: string; search: string; hash: string };

// Single source of truth for "what gets captured as the return URL when sending
// the user to the login flow". Callers pass `useLocation()` directly.
export function currentPathSuffix(location: PathLike): string {
  return location.pathname + location.search + location.hash;
}

const MAX_LENGTH = 2048;

// Auth surfaces that would re-trigger the LoggedInWithOrgContext catch-all, causing a
// two-hop redirect that ends at "/" anyway. Reject them up front so the URL doesn't lie.
const FORBIDDEN_PATHS = new Set(["/login", "/register", "/confirmation", "/init"]);

export function validateReturnTo(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value.length > MAX_LENGTH) return null;
  if (!value.startsWith("/")) return null;
  if (value.startsWith("//") || value.startsWith("/\\")) return null;
  // Reject control chars and any non-printable-ASCII (bidi overrides, format chars) — these
  // can confuse the address bar and have no legitimate place in a same-origin app path.
  if (/[^\x20-\x7E]/.test(value)) return null;
  const pathOnly = value.split(/[?#]/, 1)[0];
  if (FORBIDDEN_PATHS.has(pathOnly)) return null;
  return value;
}
